<template>
  <Tabs ref="tabs">
    <TabItem name="Peripheral">
      <iv-type-tab
        :iv-type="peripheralType"
        :readonly="readonly"
        show-gauges
        show-ports
        @updateType="updateType"
      />
    </TabItem>
    <TabItem name="Intraosseous">
      <iv-type-tab
        :iv-type="ioType"
        :readonly="readonly"
        show-sets
        @updateType="updateType"
      />
    </TabItem>
  </Tabs>
</template>

<script>
import { cloneDeep, assign } from 'lodash';
import { Tabs, TabItem } from 'vue-material-tabs';
import IvTypeTab from './IVTypeTab';

export default {
  name: 'iv-types-panel',
  components: {
    Tabs,
    TabItem,
    IvTypeTab,
  },
  props: {
    iv: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    navigation: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      defaultType: {
        ports: ['ONE_PORT'],
        matchSides: false,
        sites: [],
        gauges: [],
        salineLock: false,
      },
      tabsTheme: {
        nav: '#fff',
        navItem: '#BDBDBD',
        navActiveItem: '#6bb645',
        slider: '#6bb645',
        arrow: '#6bb645',
      },
    };
  },
  computed: {
    peripheralType() {
      let type = this.iv.types.find(t => t.type === 'PERIPHERAL');
      if (!type) {
        type = {
          ...this.defaultType,
          type: 'PERIPHERAL'
        };
      }
      return type;
    },
    ioType() {
      let type = this.iv.types.find(t => t.type === 'INTRAOSSEOUS');
      if (!type) {
        type = {
          ...this.defaultType,
          type: 'INTRAOSSEOUS'
        };
      }
      return type;
    },
  },
  watch: {
    navigation(value) {
      this.onNavigate(value);
    }
  },
  mounted() {
    this.onNavigate(this.navigation);      
  },
  methods: {
    onNavigate(value) {
      if (value && value.category === 'ivs' && value.params && value.params.type) {
        // Navigate to the tab
        let tabIndex = 0;
        if (value.params.type !== 'ANY') {
          tabIndex = value.params.type === 'INTRAOSSEOUS' ? 1 : 0;
        }
        this.$nextTick(() => {
          if (this.$refs.tabs) {
            this.$refs.tabs.switchTabItem(tabIndex);
          }
        });
      }
    },
    updateType(updatedType) {
      const updatedTypes = cloneDeep(this.iv.types);
      const index = updatedTypes.findIndex(t => t.type === updatedType.type);
      if (index >= 0) {
        updatedTypes[index] = updatedType;
      } else {
        updatedTypes.push(updatedType);
      }
      const newIv = assign({}, this.iv, { types: updatedTypes });
      this.emitUpdate(newIv);
    },
    emitUpdate(newIv) {
      this.$emit('updateIv', newIv);
    }
  }
}
</script>

<style scoped>
</style>